import { useQuery } from "@tanstack/react-query";
import { getQuestionnaireContent } from "../../services/questionnaires";
import { useParams } from "react-router-dom";

const useQuestionnaireContent = () => {
    const params = useParams();

    return useQuery({
        queryFn: () => getQuestionnaireContent(params?.questcode === ':questcode' ? 'MAIN-QUESTIONNAIRE' : params?.questcode ?? ''),
        queryKey: ["questionnaire_content"],
        staleTime: Infinity,
    });
}

export default useQuestionnaireContent;